import {
    Component,
    EventEmitter,
    forwardRef,
    HostBinding,
    Input,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { ControlValueAccessorBaseComponent } from "../base-component/control-value-accessor-base.component";
import { NgClass } from "@angular/common";

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PillToggleButtonComponent)
        }
    ],
    selector: "rask-pill-toggle-button",
    templateUrl: "./pill-toggle-button.component.html",
    styleUrls: ["./pill-toggle-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})

export class PillToggleButtonComponent extends ControlValueAccessorBaseComponent {

    @Input() text: string;
    @Input() colorTheme: PillToggleButtonColorTheme;
    @Output() hoverChange = new EventEmitter<boolean>();
    @HostBinding("class") get colorThemeAttr() { return this.colorTheme; }

    constructor() {
        super();
    }

    toggle() {
        this.value = !this.value;
    }

    protected hoverIn() {
        this.hoverChange.emit(true);
    }

    protected hoverOut() {
        this.hoverChange.emit(false);
    }

}

export type PillToggleButtonColorTheme = "skogsvardmarkberedning" | "skogsvardforyngring" | "skogsvardrojning" | "skogsvardinventering" | "skogsvardovrigt";
